import axios from '../../../services/axios';

export function authorize(data) {
  return axios.post(`/api/dashboard/authorize`, data);
}
